import { render, staticRenderFns } from "./MicroVedio.vue?vue&type=template&id=08f63034&scoped=true&"
import script from "./MicroVedio.vue?vue&type=script&lang=js&"
export * from "./MicroVedio.vue?vue&type=script&lang=js&"
import style0 from "./MicroVedio.vue?vue&type=style&index=0&id=08f63034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f63034",
  null
  
)

export default component.exports